var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4047,
    height: 14.0043,
    rx: 2.80086,
    fill: "#28C76F",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4252_8948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15967 6.96794L6.89921 8.99422L10.2623 5.13281",
    stroke: "#20E290",
    strokeWidth: 0.551684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4252_8948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.06852,
    height: 4.66809,
    fill: "white",
    transform: "translate(4.66797 4.66797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckBox);
export default __webpack_public_path__ + "static/media/green_check_box.d99bf7ea8e81c1934f7438cdc750799a.svg";
export { ForwardRef as ReactComponent };